export default __webpack_public_path__ + "static/media/cam-icon.29803ca1.svg";